import { isQualifiedBand } from '../constants/staff-bands';

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
    dataLayer?: unknown[];
  }
}

const SIGNUP_VALUE = 1;
const QUALIFIED_SIGNUP_VALUE = 500;
const CURRENCY = 'ZAR';

function getTrackingIds() {
  return [
    import.meta.env.VITE_MARKETING_GA_MEASUREMENT_ID,
    import.meta.env.VITE_GA_MEASUREMENT_ID,
    import.meta.env.VITE_GOOGLE_ADS_ID,
  ].filter(Boolean);
}

export function initAnalytics() {
  if (!import.meta.env.PROD) return;

  const trackingIds = getTrackingIds();
  if (!trackingIds.length) return;

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${trackingIds[0]}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  // gtag.js ignores plain arrays. The shim must push arguments, as Google's snippet does.
  window.gtag = function gtag() {
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer!.push(arguments);
  };
  window.gtag('js', new Date());

  trackingIds.forEach((id) => window.gtag?.('config', id));
}

export function trackSignup(method: string, staffBand: string) {
  window.gtag?.('event', 'sign_up', {
    method,
    staff_band: staffBand,
    value: SIGNUP_VALUE,
    currency: CURRENCY,
  });

  reportAdsConversion(
    import.meta.env.VITE_GOOGLE_ADS_SIGNUP_LABEL,
    SIGNUP_VALUE,
  );

  if (!isQualifiedBand(staffBand)) return;

  window.gtag?.('event', 'sign_up_qualified', {
    method,
    staff_band: staffBand,
    value: QUALIFIED_SIGNUP_VALUE,
    currency: CURRENCY,
  });

  reportAdsConversion(
    import.meta.env.VITE_GOOGLE_ADS_QUALIFIED_SIGNUP_LABEL,
    QUALIFIED_SIGNUP_VALUE,
  );
}

function reportAdsConversion(sendTo: string | undefined, value: number) {
  if (!sendTo) return;

  window.gtag?.('event', 'conversion', {
    send_to: sendTo,
    value,
    currency: CURRENCY,
  });
}
